<template>
  <div class="body_monban">
    <el-tabs style="height: 200px;" v-model="activeName">
      <el-tab-pane label="小程序轮播图"   name="lunbotu">
        <tuwen :tuwen_type="51"   :show_type="1" :update_flag ="1"></tuwen>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<style>
.body_moban {
  padding-top: 100px;
}
</style>
<script>

import tuwen from '../../tongyong/tuwen_com.vue'
export default {
  components: {
    tuwen: tuwen
  },

  data() {
    return {
      // 获取用户列表参数
      activeName: 'lunbotu'

    };
  },
  props: [],

  watch: {

  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
}
</script>
